import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Marketplace from "./pages/Marketplace";
import AdminDashboard from "./pages/AdminDashboard";
import Login from "./pages/Login";
import CheckoutSuccess from "./pages/CheckoutSuccess";
import Dashboard from "./pages/Dashboard";
import OAuthCallback from "./pages/OAuthCallback";
import AIAutoPoster from "./pages/AIAutoPoster";
import AILab from "./pages/AILab";
import PromptVault from "./pages/PromptVault";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider } from "./contexts/AuthContext";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/marketplace" element={<Marketplace />} />
            <Route path="/ai-auto-poster" element={<AIAutoPoster />} />
            <Route path="/ai-lab" element={<AILab />} />
            <Route path="/prompt-vault/:productId" element={<PromptVault />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/login" element={<Login />} />
            <Route path="/checkout/success" element={<CheckoutSuccess />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/oauth/callback" element={<OAuthCallback />} />
          </Routes>
          <Footer />
          <Toaster position="top-right" />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
